import React from "react";
import ProductGrid from "../components/ProductGrid";
import shopHeroImage from "../assets/shop/ship44.png";
import SeoManager from "../SeoManager";

export default function ShopPage() {
  return (
    <div className="shop-page">
      <SeoManager
        title="Shop Gold Jewelry"
        description="Browse the Asher Jewels PH catalog by jewelry type, karat, brand, and price range. Explore gold pieces curated for gifting, collecting, and everyday wear."
        path="/shop"
        image={shopHeroImage}
        keywords="shop gold jewelry, gold jewelry catalog Philippines, gold bracelets, gold necklaces, gold rings, Asher Jewels shop"
      />
      <section className="shop-hero">
        <div className="shop-hero__content">
          <p className="shop-hero__eyebrow">Shop Asher Jewels</p>
          <h1>Discover Gold Pieces Curated for Every Style</h1>
          <p>
            Explore the latest Asher Jewels collection in one dedicated space and
            browse by category, karat, brand, and price with ease.
          </p>
        </div>
        <div className="shop-hero__media">
          <img src={shopHeroImage} alt="Asher Jewels shop collection" />
        </div>
      </section>

      <ProductGrid />
    </div>
  );
}
